import {Dialog} from "primereact/dialog";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import ProjectService from "./ProjectService";

type UpdateStationProps = {
    modal: boolean;
    data: any
    hidePopup: () => void;
    showSuccess: () => void;
}
const UpdateStation = (props: UpdateStationProps) =>{
    const { t } = useTranslation();
    const [errors, setErrors] = useState<any>({});
    const [stationName, setStationName] = useState<string>("");
    const projectService = new ProjectService();
    const validate = ()=>{
        let error: any = {};
        if(stationName === ""){
            error["station"] = t("station_name_error");
            setErrors(error);
        }
        const specialCharPattern = /[äüß]/;
        if (specialCharPattern.test(stationName)) {
            error["station"] = t("station_name_special_char_error");
            setErrors(error);
        }
        if (Object.keys(error).length > 0) {
            return false;
        }
        return true;
    }
    const renderFooter = () => {
        return (
            <div>
                <Button
                    label={t("cancel")}
                    icon="pi pi-times"
                    onClick={() => props.hidePopup()}
                    className="p-button-text"
                />
                <Button
                    className="create-plant"
                    label={t("update_station")}
                    icon="pi pi-check"
                    onClick={() => {
                        setErrors({});
                        if(validate()){
                            const body = {
                                station: props.data['station'],
                                project_id: props.data['project_id'],
                                user_id: props.data['user_id'],
                                new_station: stationName,
                                did: props.data['did']
                            }
                            projectService.updateStationName(body).then(response =>{
                                if(response['data']['error'] === 'The station name already exists'){
                                    let error: any = {};
                                    error["station_exist"] = t("station_name_exist");
                                    setErrors(error)
                                }
                                else{
                                    props.showSuccess();
                                    props.hidePopup();
                                }
                            })
                        }
                    }}
                    autoFocus
                />
            </div>
        );
    };

    return(
        <>
            <Dialog
                header={t("update_station")}
                visible={props.modal}
                style={{ width: "30vw" }}
                footer={renderFooter()}
                onHide={() => props.hidePopup()}
            >
                <div>

                    <div className="grid align-items-center mb-3">
                        <div className="col-12 lg:col-4">
                            <h5 className="mb-3">{t("current_station_name")}</h5>
                        </div>
                        <div className="col-12 lg:col-6">
                            <InputText className={'mt-2'} disabled value={props.data['station']}/>
                        </div>
                    </div>

                    <div className="grid align-items-center">
                        <div className="col-12 lg:col-4">
                            <h5 className="mb-3">{t("new_station")}</h5>
                        </div>
                        <div className="col-12 lg:col-6">
                            <InputText className={'mt-2'} value={stationName} onChange={(e)=>{setStationName(e.target.value)}}/>
                            <p className="error-message">{errors["station"]}</p>
                            <p className="error-message">{errors["station_exist"]}</p>

                        </div>
                    </div>

                </div>
            </Dialog>
        </>
    )
}

export default UpdateStation;